import { Box, Stack, Typography, IconButton, Dialog, useTheme, Popover, Button,
  CircularProgress, List, ListItemButton, ListItemIcon, Divider
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CustomAvatar from '../../../component/CustomAvatar';
import { CommentType, PostType } from '../memeverse_types';
import React, { useEffect, useRef, useState, Fragment } from 'react';
import { timeAgo } from '../../../utils/helper';
// import GenerateIcon from '../../../svg/MemeverseIcons/GenerateIcon';
import CommentIcon from '../../../svg/MemeverseIcons/CommentIcon';
import HeartIcon from '../../../svg/MemeverseIcons/HeartIcon';
import ShareIcon2 from '../../../svg/ShareIcon2';
import CreateUpdateComment from '../CreateUpdateComment';
import { useAuth } from '../../../hooks/useAuth';
import DeleteIcon from '../../../svg/MemeverseIcons/DeleteIcon';
import { createCommentLike, deleteComment,
  followCreator, incrementViewOnComment } from '../../../utils/apis/memeverse';
// import { useNavigate } from 'react-router-dom';
// import EditIcon from '../../../svg/MemeverseIcons/EditIcon';
import FollowIcon from '../../../svg/MemeverseIcons/FollowIcon';
import ReportIcon from '../../../svg/MemeverseIcons/ReportIcon';
import AIAgentAvatar from '../../../component/AIAgentAvatar';
import TwoStarsIcon from '../../../svg/MemeverseIcons/TwoStarsIcon';
import { useChannel } from 'ably/react';
import { TypingIndicator } from '@chatscope/chat-ui-kit-react';
import './MemeReply.css';
import { toast } from 'react-toastify';
import { reportComment } from '../../../utils/api';
import { ReactComponent as FacebookIcon } from '../../../svg/Shareicons/facebook.svg';
import { ReactComponent as TwitterIcon } from '../../../svg/Shareicons/twitter.svg';
import { ReactComponent as LinkedinIcon } from '../../../svg/Shareicons/linkedin.svg';
import { ReactComponent as WhatsappIcon } from '../../../svg/Shareicons/whatsapp.svg';
import { ReactComponent as TelegramIcon } from '../../../svg/Shareicons/telegram.svg';
import { ReactComponent as RedditIcon } from '../../../svg/Shareicons/reddit.svg';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  RedditShareButton,
} from 'react-share';
import ReplyIcon from '../../../svg/MemeverseIcons/ReplyIcon';
import useAnalyticsEventTracker from '../../../hooks/useAnalyticsEventTracker';
import Markdown from '../../userChat/Markdown';

interface MemeReplyProps {
  parentPostOrComment: PostType | CommentType;
  reply: CommentType;
  showNested: boolean;
  shouldLimitLength: boolean;
  allComments: Record<string, CommentType>;
}

const MemeReply: React.FC<MemeReplyProps> =
  ({ parentPostOrComment, reply, showNested, shouldLimitLength, allComments }) => {
  const {
    docId,
    comment,
    level,
    updatedAt,
    like_counts,
    reply_counts,
    user_id,
    isThinking,
    user_details,
    is_liked,
    show_typing,
    flat_comments_list,
  } = reply;

  const [ showCreateComment, setShowCreateComment ] = useState<boolean>(false);
  const [ moreMenuOpen, setMoreMenuOpen ] = useState<boolean>(false);
  const [ deleteConfirmation, setDeleteConfirmation ] = useState<boolean>(false);
  const [ isDeleting, setIsDeleting ] = useState<boolean>(false);
  const [ showEditComment, setShowEditComment ] = useState<boolean>(false);
  const currNumWords = useRef<number>(Math.round(Math.random() * 6 + 4));
  const [ displayMessage, setDisplayMessage ] = useState<string>(
    (!!comment?.length) ? (show_typing ?
    comment[comment.length - 1]?.comment_body.split(' ').slice(0, currNumWords.current).join(' ') :
    comment[comment.length - 1]?.comment_body) : '')
  const [ likedStatus, setLikedStatus ] = useState<{status: boolean, count: number}>(
    {status: !!is_liked, count: like_counts});
  const [showReportConfirm, setShowReportConfirm] = useState(false);
  const [showReportThanks, setShowReportThanks]   = useState(false);
  const [replyShareOpen, setReplyShareOpen] = useState(false);

  const moreMenuAnchor = useRef(null);
  const isMounted = useRef<boolean>(false);
  const commentRef = useRef<any>(null);
  const hasSeenComment = useRef<boolean>(false);

  // const navigate = useNavigate();
  const theme = useTheme();
  const { authUser, setLoginModalVisible } = useAuth();
  const eventTracker = useAnalyticsEventTracker();
  const { publish } = useChannel('ask');
  const handleReplyShareOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setReplyShareOpen(true);
  };
  const handleReplyShareClose = () => setReplyShareOpen(false);


  useEffect(() => {
    if (isMounted.current) {
      if (showCreateComment) {
        publish("comment.thinking.new", {
          userId: authUser?.uid,
          parentId: docId,
          userType: 'user',
          authorId: user_id,
          user_details: {
            userName: authUser?.userName,
            profilePicUrl: authUser?.profilePicUrl,
            fullName: authUser?.fullName,
            user_id: authUser?.uid,
          }
        })
      } else {
        publish("comment.thinking.remove", {
          userId: authUser?.uid,
          parentId: docId,
          userType: 'user',
          authorId: user_id,
        })
      }
    } else {
      isMounted.current = true;
    }
  }, [showCreateComment]) //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    try {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && isMounted.current && !hasSeenComment.current) {
          hasSeenComment.current = true;
          incrementViewOnComment(authUser?.uid, docId)
            .catch(err => {

            })
        }
      });

      observer.observe(commentRef.current);

      return () => {
        observer.disconnect();
      }
    } catch (err) {

    }
  }, [isMounted.current, hasSeenComment.current]) //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (show_typing && !!comment?.length) {
      let targetWords = comment[comment.length - 1]?.comment_body.split(' ');
      if (currNumWords.current < targetWords.length) {
        currNumWords.current += Math.round(Math.random() * 6 + 4); // add 4 to 10 words
        setTimeout(() => {
          setDisplayMessage(targetWords.slice(0, currNumWords.current).join(' '));
        }, 100)
      }
    }
  }, [show_typing, displayMessage]) //eslint-disable-line react-hooks/exhaustive-deps

  // const handleGenerate = () => {

  // }

  const handleMoreMenu = () => {
    setMoreMenuOpen(!moreMenuOpen)
  }

  const handleComment = () => {
    if (authUser) {
      setShowCreateComment(!showCreateComment)
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      })
    }
  }

  const handleLike = () => {
    if (authUser) {
      setLikedStatus((prev) => {
        if (prev.status) {
          return {
            status: false,
            count: prev.count - 1,
          }
        } else {
          return {
            status: true,
            count: prev.count + 1,
          }
        }
      })
      createCommentLike(authUser.uid, docId)
        .catch((err) => {
          console.log('Like failed: ', err)
        })
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      })
    }
  }

  // const handleShare = () => {

  // }

  // const handleEdit = () => {
  //   setShowEditComment(true)
  //   setMoreMenuOpen(false)
  // }

  const handleDeleteConfirmation = () => {
    setDeleteConfirmation(!deleteConfirmation)
  }

  const handleFollow = () => {
    if (authUser) {
      followCreator(authUser.uid, user_id)
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((data) => {
          // data has "action": "followed", "docId": "id", "success": "true"
          // just check existence of docId
          if (data.docId) {
            toast.success(
              `Now following ${user_details?.fullName || 'creator'}`
            );
          } else {
            toast.warning(
              `Unfollowed ${user_details?.fullName || 'creator'}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setMoreMenuOpen(false);
        });
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      })
    }
  }

  const handleReport = () => {
    if (!authUser) {
      return setLoginModalVisible({ isOpen: true, formType: 'signin', currentStep: 1 });
    }
    setMoreMenuOpen(false);
    setShowReportConfirm(true);
  };

  const submitReportComment = async () => {
    try {
      // `parentPostId` must be the ID of the post this comment belongs to.
      await reportComment(
        authUser.uid,
        (parentPostOrComment as PostType).docId,  // your post ID
        docId,                                    // this comment’s ID
        comment[comment.length - 1]?.comment_body || ''
      );
      setShowReportConfirm(false);
      setShowReportThanks(true);
    } catch (err) {
      console.error(err);
      toast.error('Failed to submit report');
    }
  };


  const handleDelete = async () => {
    setIsDeleting(true)
    deleteComment(authUser?.uid, docId)
      .then(() => {
        setDeleteConfirmation(false)
        setMoreMenuOpen(false)
        setIsDeleting(false)
      })
  }

  if (!displayMessage) {
    // skip comment if it's empty
    return <></>
  }

  const FloatingArc: React.FC<{radius: number, stroke: string, strokeWidth: number}> =
    ({radius=5, stroke='black', strokeWidth=2}) => {
      const diameter = 2 * radius;
      const d = `
        M ${radius} ${diameter}
        A ${radius} ${radius} 0 0 1 0 ${radius}
      `;

      return (
        <Box sx={{ position: 'relative', zIndex: 10 }}>
          <Box
            component="svg"
            sx={{
              position: 'absolute',
              top: -diameter + 25,
              left: -diameter + 8,
              pointerEvents: 'none',
              overflow: 'visible',
              stroke: stroke,
              strokeWidth: strokeWidth
            }}
            width={diameter}
            height={diameter}
          >
            <path
              d={d}
              fill="none"
              stroke='inherit'
              strokeWidth='inherit'
            />
          </Box>
        </Box>
      )
  }

  return (
    <Stack
      className="meme-reply"
      direction="column"
      sx={{
        width: '100%',
      }}
      onClick={(e) => {
        e.stopPropagation();
        console.log(reply.docId, reply.parent_comment_id, reply.parent_post_id)
      }}
    >
      <Stack
        ref={commentRef}
        direction="row"
        sx={{
          width: '100%',
          mt: {xs: 0, sm: 1},
          gap: {xs: 1.5, md: 2},
        }}
      >
        {/* Left column: Avatar and vertical line */}
        <Stack
          direction="column"
          alignItems="center"
          sx={{
            width: '48px',
            mt: 1.5,
          }}
        >
          {/* {
            (level > 0 && !isThinking) &&
              <FloatingArc
                radius={38}
                stroke={'#E0E0E0'} // same as grey.300
                strokeWidth={2}
              />
          } */}
          {
            comment[0]?.commenter_type === 'agent' ?
              <AIAgentAvatar
                src={user_details?.profilePicUrl}
                sx={{
                  width: 48,
                  height: 48,
                  overflow: 'hidden',
                  '& .MuiAvatar-img':
                    {
                      objectFit: 'cover',
                      objectPosition: 'center 1%',
                      transform: 'scale(0.87)',
                      transformOrigin: 'center'
                    }
                  }}
              /> :
              <CustomAvatar
                src={user_details?.profilePicUrl}
                sx={{ width: 48, height: 48 }}
              />
          }
          {
            <Box
              className={(showNested && !!reply_counts) ? "always-show" : "meme-reply-vertical-line"}
              sx={{
                flexGrow: 1,
                borderLeft: '2px solid',
                borderColor: 'grey.300',
                mt: 1
              }}
            />
          }
        </Stack>

        {
          level > 0 && <Box
              className={(showNested && !!reply_counts) ? "always-show" : "meme-reply-vertical-line"}
              sx={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                flexGrow: 1,
                borderLeft: '2px solid',
                borderColor: 'grey.300',
                mt: 1
              }}
            />
        }

        {/* Right column: Reply content */}
        <Stack
          direction="column"
          spacing={0.5}
          sx={{
            flex: 1,
            maxWidth: 'calc(100% - 48px - 12px)',
          }}
        >
          <Divider sx={{mb: {xs: 0.5, sm: 1}}}/>
          {/* User info row */}
          <Stack
            direction="row"
            spacing={1}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent='space-between'
            sx={{
              maxWidth: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
                flexWrap: 'wrap',
                rowGap: 0,
                overflow: 'hidden',
              }}
            >
              <Typography variant="h7" color="text.primary" sx={{ fontWeight: 600 }}>
                {user_details?.fullName}
              </Typography>
              {
                (comment[0]?.commenter_type === 'agent') &&
                <Box sx={{display: 'flex', gap: 1, ml: -0.5, alignItems: 'center'}}>
                  <TwoStarsIcon />
                  <Typography variant="body2" color="text.secondary">
                    Expert AI Agent
                  </Typography>
                </Box>
              }
              <Typography variant="body2" color="text.secondary">
                @{user_details?.userName}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{whiteSpace: 'nowrap',}}>
                &#x2022;
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {timeAgo(updatedAt)}
              </Typography>
            </Box>
            <Box ref={moreMenuAnchor}>
              <IconButton
                size="small"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleMoreMenu();
                }}
              >
                <MoreHorizIcon />
              </IconButton>
              <Popover
                open={moreMenuOpen}
                anchorEl={moreMenuAnchor.current}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                onClose={handleMoreMenu}
              >
                <Box
                  display='flex'
                  flexDirection='column'
                  // p={1}
                  // gap={1.5}
                >
                  {
                    authUser?.documentId === user_id ?
                    (
                      deleteConfirmation ?
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          p: 3,
                          gap: 4,
                          maxWidth: "450px",
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.5,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1.5,
                              stroke: (theme) => theme.palette.error.main,
                            }}
                          >
                            <DeleteIcon width={28} stroke="inherit"/>
                            <Typography variant="h6">
                              Delete Comment?
                            </Typography>
                          </Box>
                          <Typography variant="body1">
                            This can't be undone and it will be removed for your profile, the timeline of any accounts that follow you, and from any accounts that have replied to you.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                            gap: 2,
                          }}
                        >
                          <Button variant="outlined"
                            onClick={(event) => {
                              event.preventDefault()
                              event.stopPropagation()
                              handleDeleteConfirmation()
                            }}
                          >
                            Cancel
                          </Button>
                          <Button variant="contained" color="error"
                            onClick={(event) => {
                              event.preventDefault()
                              event.stopPropagation()
                              handleDelete()
                            }}
                            startIcon={isDeleting ?
                                        <CircularProgress size={20} color='inherit'/> :
                                        <></>
                                      }
                          >
                            Delete Comment
                          </Button>
                        </Box>
                      </Box> :
                      <List>
                        {/* <ListItemButton
                          onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            handleEdit()
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              p: 0,
                              pr: 2,
                              fill: (theme) => theme.palette.primary.main,
                            }}
                          >
                            <EditIcon width={19} fill="inherit"/>
                          </ListItemIcon>
                          <Typography variant="body2">
                            {`Edit Comment`}
                          </Typography>
                        </ListItemButton> */}

                        <ListItemButton
                          onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            handleDeleteConfirmation()
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              p: 0,
                              pr: 2,
                              stroke: (theme) => theme.palette.error.main,
                            }}
                          >
                            <DeleteIcon width={19} stroke="inherit"/>
                          </ListItemIcon>
                          <Typography variant="body2" color="error.main">
                            {`Delete`}
                          </Typography>
                        </ListItemButton>
                      </List>
                    ) :
                    <List>
                      {
                        (comment[comment.length-1]?.commenter_type !== 'agent') &&
                        <ListItemButton
                          onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            handleFollow()
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              p: 0,
                              pr: 2,
                              fill: (theme) => theme.palette.primary.main,
                              stroke: (theme) => theme.palette.primary.main,
                            }}
                          >
                            <FollowIcon width={19} fill="inherit" stroke="inherit"/>
                          </ListItemIcon>
                          <Typography variant="body2">
                            {`Follow @${user_details?.userName}`}
                          </Typography>
                        </ListItemButton>
                      }
                      <ListItemButton
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          handleReport();
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            p: 0,
                            pr: 2,
                            fill: (theme) => theme.palette.primary.main,
                          }}
                        >
                          <ReportIcon width={19} fill="inherit" />
                        </ListItemIcon>
                        <Typography variant="body2">Report Comment</Typography>
                      </ListItemButton>
                    </List>
                  }
                </Box>
              </Popover>
            </Box>
          </Stack>
          {/* Reply text row */}
          {
            isThinking ?
            <Box display='flex' gap={0.25} alignItems='flex-end'>
              <Typography
                variant="body1"
                color="text.primary"
                mb={{xs: 0, sm: 0.5, md: 1}}
                mt={-0.5}
              >
                Thinking
              </Typography>
              <Box
                mb={{xs: 0.75, sm: 1.25, md: 1.75}}
                mt={-0.5}
              >
                <TypingIndicator
                  className='reply-thinking'
                />
              </Box>
            </Box> :
            <Typography
              variant="body1"
              color="text.primary"
              mb={{xs: 0, sm: 0.5, md: 1}}
              mt={-0.5}
              component="div"
              sx={shouldLimitLength ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
              } : {}}
            >
              <Markdown className={`markdown`}>
                {displayMessage}
              </Markdown>
            </Typography>
          }
          {/* Actions row */}
          <Stack direction="row" justifyContent="flex-start" sx={{gap: {xs: 0, sm: 1, md: 1.5}}}>

            {/* <Stack direction="row" alignItems="center" spacing={0.5}>
              <IconButton
                size="small"
                sx={{
                  stroke: (theme) => theme.palette.text.secondary,
                  fill: (theme) => theme.palette.text.secondary,
                }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleGenerate();
                }}
              >
                <GenerateIcon stroke="inherit" fill="inherit"/>
              </IconButton>
            </Stack> */}

            {
              'content' in parentPostOrComment && // would be false for a reply
              <>
                <Stack direction='row' alignItems='center' spacing={0.5}>
                  <IconButton
                    size='small'
                    sx={{
                      stroke: (theme) => theme.palette.text.secondary,
                      borderRadius: (theme) => theme.shape.borderRadiusLg,
                      px: {xs: 1, md: 1.5},
                      ml: {xs: '-8px !important', md: '-12px !important'},
                    }}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleComment();
                    }}
                  >
                    <ReplyIcon stroke='inherit'/>
                    <Typography variant='body2' color='text.secondary' sx={{ml: 0.5}}>
                      Reply
                    </Typography>
                  </IconButton>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <IconButton
                    size="small"
                    sx={{
                      stroke: (theme) => theme.palette.text.secondary,
                      borderRadius: (theme) => theme.shape.borderRadiusLg,
                      px: {xs: 1, md: 1.5},
                    }}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleComment();
                    }}
                  >
                    <CommentIcon stroke="inherit"/>
                    <Typography variant="body2" color="text.secondary" sx={{ml: 0.5}}>
                      {reply_counts}
                    </Typography>
                  </IconButton>
                </Stack>
              </>
            }

            <Stack direction="row" alignItems="center" spacing={0.5}>
              <IconButton
                size="small"
                sx={{
                  stroke: (theme) => theme.palette.text.secondary,
                  borderRadius: (theme) => theme.shape.borderRadiusLg,
                  px: {xs: 1, md: 1.5},
                }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleLike();
                }}
              >
                <HeartIcon
                  stroke={likedStatus.status ? 'red' : "inherit"}
                  fill={likedStatus.status ? 'red' : 'none'}
                />
                <Typography variant="body2" color="text.secondary" sx={{ml: 0.5}}>
                  {likedStatus.count}
                </Typography>
              </IconButton>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={0.5}>
              <IconButton
                size="small"
                sx={{ stroke: theme => theme.palette.text.secondary }}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleReplyShareOpen(e);
                }}
              >
                <ShareIcon2 stroke="inherit" />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>

        {/* For editing a comment */}
        <Dialog
          open={showEditComment}
          onClose={() => setShowEditComment(false)}
          fullWidth
          maxWidth='md'
          slotProps={{
            backdrop: {
              sx: {
                display: {xs: 'none', md: 'block'},
              },
            },
          }}
          PaperProps={{
            sx: {
              m: 0,
              [theme.breakpoints.down('md')]: {
                width: '100%',
                maxWidth: '100%',
                height: 'calc(100% - 107px)',
                maxHeight: 'none',
                boxShadow: 'none',
                mt: '50px',
              }
            }
          }}
          sx={{
            [theme.breakpoints.down('md')]: {
              '& .MuiDialog-container': {
                alignItems: 'flex-start'
              }
            }
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <CreateUpdateComment
            setCreateUpdateCommentVisible={setShowEditComment}
            parentPostOrComment={parentPostOrComment}
            existingComment={reply}
          />
        </Dialog>

        {/* For creating new comment on comment */}
        <Dialog
          open={showCreateComment}
          onClose={() => setShowCreateComment(false)}
          fullWidth
          maxWidth='md'
          slotProps={{
            backdrop: {
              sx: {
                display: {xs: 'none', md: 'block'},
              },
            },
          }}
          PaperProps={{
            sx: {
              m: 0,
              [theme.breakpoints.down('md')]: {
                width: '100%',
                maxWidth: '100%',
                height: 'calc(100% - 107px)',
                maxHeight: 'none',
                boxShadow: 'none',
                mt: '50px',
              }
            }
          }}
          sx={{
            [theme.breakpoints.down('md')]: {
              '& .MuiDialog-container': {
                alignItems: 'flex-start'
              }
            }
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <CreateUpdateComment
            setCreateUpdateCommentVisible={setShowCreateComment}
            parentPostOrComment={reply}
          />
        </Dialog>

        {/* Confirm report dialog */}
        <Dialog
          open={showReportConfirm}
          onClose={() => setShowReportConfirm(false)}
          fullWidth
          maxWidth="xs"
        >
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Report this comment?
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Are you sure you want to report this comment for review?
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
              <Button onClick={() => setShowReportConfirm(false)}>
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={submitReportComment}>
                Yes, report
              </Button>
            </Stack>
          </Box>
        </Dialog>

        {/* Thank‑you dialog */}
        <Dialog
          open={showReportThanks}
          onClose={() => setShowReportThanks(false)}
          fullWidth
          maxWidth="xs"
        >
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Thanks!
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Your report has been sent and will be reviewed.
            </Typography>
            <Button onClick={() => setShowReportThanks(false)}>
              Close
            </Button>
          </Box>
        </Dialog>

        <Dialog
          open={replyShareOpen}
          onClose={handleReplyShareClose}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: 4,
              p: 2,
              backdropFilter: 'blur(8px)',
              backgroundColor: 'rgba(255,255,255,0.85)',
            }
          }}
          onClick={e => e.stopPropagation()}
        >
          <Typography variant="h6" textAlign="center" mb={2}>
            Share this reply
          </Typography>
          <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap">
            {/** Facebook **/}
            <FacebookShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'facebook',
                })
              }}
            >
              <IconButton><FacebookIcon width={40} height={40} /></IconButton>
            </FacebookShareButton>
            {/** Twitter **/}
            <TwitterShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              title={comment[comment.length-1].comment_body}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'twitter',
                })
              }}
            >
              <IconButton><TwitterIcon width={40} height={40} /></IconButton>
            </TwitterShareButton>
            {/* LinkedIn */}
            <LinkedinShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'linkedin',
                })
              }}
            >
              <IconButton>
                <LinkedinIcon width={40} height={40} />
              </IconButton>
            </LinkedinShareButton>

            {/* WhatsApp */}
            <WhatsappShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              title={comment[comment.length-1].comment_body}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'whatsapp',
                })
              }}
            >
              <IconButton>
                <WhatsappIcon width={40} height={40} />
              </IconButton>
            </WhatsappShareButton>

            {/* Telegram */}
            <TelegramShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              title={comment[comment.length-1].comment_body}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'telegram',
                })
              }}
            >
              <IconButton>
                <TelegramIcon width={40} height={40} />
              </IconButton>
            </TelegramShareButton>
            {/* Reddit */}
            <RedditShareButton
              url={`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              title={comment[comment.length-1].comment_body}
              onClick={e => {
                e.stopPropagation()
                eventTracker('ask-share', {
                  type: 'comment',
                  location: 'reddit',
                })
              }}
            >
              <IconButton>
                <RedditIcon width={40} height={40} />
              </IconButton>
            </RedditShareButton>

          </Stack>
          <Box mt={2}>
            <Typography variant="body2" color="text.secondary" mb={1}>
              Link
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Box
                onClick={e => e.stopPropagation()}
                sx={{
                  bgcolor: '#f5f5f5',
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  flexGrow: 1,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {`${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`}
              </Box>
              <Button
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(
                    `${window.location.origin}/ask/post/${(parentPostOrComment as PostType).docId}#comment-${docId}`
                  );
                  eventTracker('ask-share', {
                    type: 'comment',
                    location: 'link',
                  })
                  handleReplyShareClose();
                }}
              >
                Copy
              </Button>
            </Stack>
          </Box>
        </Dialog>


      </Stack>
      {
        showNested && flat_comments_list &&
        <Box sx={{ml: 8.5, mt: 1}}>
          {
            flat_comments_list.map((commentId) => {
              return !!allComments[commentId] ?
              <Fragment key={`comment-${commentId}`}>
                {/* <Box
                  className="meme-reply-vertical-line"
                  sx={{
                    flexGrow: 1,
                    borderLeft: '2px solid',
                    borderColor: 'grey.300',
                    mt: 1
                  }}
                /> */}
                <MemeReply
                  parentPostOrComment={reply}
                  reply={allComments[commentId]}
                  showNested={showNested}
                  shouldLimitLength={shouldLimitLength}
                  allComments={allComments}
                />
              </Fragment> :
              <Fragment key={`comment-${commentId}`}/>
            })
          }
        </Box>
      }
    </Stack>

  );
};

// // only update component when content or immediate children are updated
// export default memo(MemeReply, (prevProps, nextProps) => {
//   return (prevProps.reply?.comment === nextProps.reply?.comment) &&
//     (prevProps.reply?.flat_comments_list === nextProps.reply?.flat_comments_list) &&
//     (prevProps.reply?.reply_counts === nextProps.reply?.reply_counts)
// });

export default MemeReply;
